// ResetPasswordPage — wire @cnv/ui/pages/auth/ResetPasswordPage với branding của cụm này.
//
// Đây LÀ trang mà link trong email đặt lại mật khẩu trỏ tới:
// `{PUBLIC_ADMIN_BASE_URL}/reset-password?token=…` (kernel `buildResetUrl`). Đổi đường dẫn
// route bên dưới là mọi email ĐÃ GỬI đều chết — muốn đổi thì phải đổi kèm kernel.
//
// Host cung cấp qua useAuth(): `resetPassword(token, pwd)` (bắt buộc) và
// `verifyResetToken(token)` (để báo "link hết hạn" NGAY khi mở trang, thay vì để người dùng
// gõ xong mật khẩu mới rồi mới báo lỗi).

import ResetPasswordPage from '@cnv/ui/pages/auth/ResetPasswordPage';

export default function ResetPasswordPageSaas() {
  return (
    <ResetPasswordPage
      logoSrc="/siteconnect.png"
      logoAlt="Site Connect"
      brandName="Site Connect"
      tagline="PROJECTS · SCHEDULING · TIME TRACKING"
      variant="blue"
      loginHref="/login"
      forgotHref="/forgot-password"
    />
  );
}
